import React, { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const SolutionsMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 50);
  };

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span
        className="text-foreground hover:text-nation-blue transition-colors cursor-pointer inline-flex items-center gap-1"
        onClick={() => setIsOpen((prev) => !prev)}
        tabIndex={0}
      >
        Solutions
        <ChevronDown
          size={16}
          className={`ml-1 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </span>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-72 bg-background border border-border rounded-lg shadow-lg z-50">
          <div className="py-2">
            <Link
              to="/solutions/government"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">Government & Public Sector</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Real-time citizen sentiment for policy decisions
              </p>
            </Link>
            <Link
              to="/solutions/political-campaigns"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">Political Campaigns</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Geo-targeted voter insights for winning strategies
              </p>
            </Link>
            <Link
              to="/solutions/ngos-advocacy"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">NGOs & Advocacy Groups</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Mobilize support with real-time community insights
              </p>
            </Link>
            <Link
              to="/solutions/corporate-marketing"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">
                Corporate Marketing & Brand Teams
              </div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                AI-powered brand sentiment monitoring and protection
              </p>
            </Link>
            <Link
              to="/solutions/academic-research"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">
                Academic Researchers & Think Tanks
              </div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Longitudinal public opinion data for publishable research
              </p>
            </Link>
            <Link
              to="/solutions/media-journalism"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors border-b border-border/50"
            >
              <div className="font-semibold">
                Media Organizations & Journalists
              </div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Real-time sentiment data for credible, data-driven reporting
              </p>
            </Link>
            <Link
              to="/solutions/verified-pollsters"
              className="block px-4 py-3 text-sm font-medium text-foreground hover:bg-muted/50 hover:text-nation-blue transition-colors"
            >
              <div className="font-semibold">Become a Verified Pollster</div>
              <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
                Earn rewards for sharing your opinions on important issues
              </p>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default SolutionsMenu;
